import isEqual from 'lodash/isEqual';
import type {MetadataExports, WorkV4} from '../types';
import {getWorkExportProps} from './getWorkExportProps';

export const updateWorkExportProps = (
  work: WorkV4,
  currentExports: MetadataExports | undefined,
): MetadataExports => {
  const newProps = getWorkExportProps(work);
  return currentExports
    ? isEqual(currentExports.work, newProps)
      ? currentExports
      : {
          ...currentExports,
          work: newProps,
        }
    : {
        work: newProps,
        expressions: {},
        manifestations: {},
      };
};
